// Component
const AddPet = () => import(/* webpackPrefetch: true, webpackChunkName: "add-pet" */ '@/app/views/main-view/_shared/_components/add-pet/add-pet.vue');

// Services
import PetsService from '@/app/services/main/pets/pets-service';
import userService from '@/app/services/main/user/user-service.js';

// Mixins
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Third party libraries
import DatePicker from 'vue2-datepicker';
import EventBus from '@/app/bus/event-bus';
import * as $ from 'jquery';

export default {
	name: 'ModalAddPet',
	components: {
		AddPet,
		DatePicker
	},
	mixins: [
		userMixins,
		toastMessageMixins,
		dateMixins
	],
	computed: {
		getAddPetDetails() {
			return this.$store.getters.getAddPetDetails;
		}
	},
	data() {
		return {
			isDisabled : true,
			isApiLoading : true
		}
	},
	beforeDestroy() {
		this.$store.commit('clearAddPetDetails');
		this.closeModal();
	},
	methods: {
		addPet() {
			if(this.isDisabled) {
				return;
			}
			
			this.isApiLoading = true;
			let petDetails = {
				formDetails: {
					"name": this.getAddPetDetails.name,
					"breedId": parseInt(this.getAddPetDetails.breedId),
					"birthdate": this.dateToISO(this.getAddPetDetails.birthdate),
					"gender": this.getAddPetDetails.gender,
					"newBreed": {}
				},
				petImg: this.getAddPetDetails.petImageUpload[0]
			};

			// Append breed info to be added
			if (parseInt(this.getAddPetDetails.breedId) <= 0) {
				petDetails.formDetails.newBreed = {
					breedName: this.getAddPetDetails.breedName,
					breedSize: this.getAddPetDetails.breedSize
				}
			}

			// add pet api
			PetsService.postPet(petDetails)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.isApiLoading = false;
						this.closeModal();

						this.$swal({
							imageHeight: '30px',
							imageUrl: `${require('@/assets/images/_shared/success-dog.png')}`,
							imageAlt: 'Success Dog',
							title: 'Awesome!',
							text: `Successfully added ${this.getAddPetDetails.name} as one of your pets.`,
							confirmButtonColor: '#4B8BFF',
							confirmButtonText: 'Got it'
						}).then(() => {
							this.getUserDetailsAPIThenSwitchPet();
						});
							
					} else {
						this.isApiLoading = false;
						const { ERROR_ADD_PET } = this.toastMessages.pet();
						this.showAPIErrorToast(ERROR_ADD_PET, res);
					}   
				});
		},
		getUserDetailsAPIThenSwitchPet() {
			const { emailAddress } = this.getUserDetails();

			// lmdc get logged in user api
			userService.getLoggedInUser(emailAddress)
			.then(res => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.$store.commit('setUserDetails', res.data.userDetails);

					// switch pet
					this.$store.commit('setActivePet', this.getUserPets[this.getUserPets.length - 1]);
					EventBus.$emit('petSwitched');
				} else {
					this.showGenericErrorToast();
				}
			});
		},
		show() {
			this.$refs.addPet.clearFields();
			$(this.$refs.modalAddPet).modal('show');
		},
		closeModal() {
			$(this.$refs.modalAddPet).modal('hide');
		},
		enableAddPet(isDisabled) {
			this.isDisabled = isDisabled;
		},
		apiLoadingDone(isApiLoading) {
			this.isApiLoading = isApiLoading;
		}
	}
}